var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#F79009"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5865_5062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.3335 9.83325H11.6668",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6668 6.16667L10.0002 7.5L8.00016 5.5L6.00016 7.5L4.3335 6.16667V10.5C4.3335 10.6768 4.40373 10.8464 4.52876 10.9714C4.65378 11.0964 4.82335 11.1667 5.00016 11.1667H11.0002C11.177 11.1667 11.3465 11.0964 11.4716 10.9714C11.5966 10.8464 11.6668 10.6768 11.6668 10.5V6.16667Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5865_5062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(4 4.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCrown);
export default __webpack_public_path__ + "static/media/circle_crown.d90f3a9edae10c50909daf3b96636715.svg";
export { ForwardRef as ReactComponent };